import styled from 'styled-components';

export default styled.div`
  background-color: #f7fafc;
  padding: 1em 2em;
`;



// WEBPACK FOOTER //
// ./src/modules/common/Container.js